























































































import {Component, Prop} from 'vue-property-decorator'
import NetworkTag from '@/components/NetworkTag.vue'
import neonWalletIcon from '@/assets/img/neonwallet.png'
import neolineIcon from '@/assets/img/neoline.png'
import walletConnectIcon from '@/assets/img/walletconnect.svg'
import {WalletPlatform} from '@/enums/WalletPlatform'
import {$} from '@/facade'
import {BrowserHelper} from '@/helpers/BrowserHelper'
import {MixinScreenSize} from '@/components/mixins/MixinScreenSize'
import ConnectWalletMenu from '@/components/walletConnection/ConnectWalletMenu.vue'
import ConnectWalletOption from '@/components/walletConnection/ConnectWalletOption.vue'
import {NetworkNamespace} from '@/enums/NetworkNamespace'

@Component({
  components: {
    ConnectWalletMenu,
    ConnectWalletOption,
    NetworkTag,
  },
  computed: {
    BrowserHelper() {
      return BrowserHelper
    },
    $() {
      return $
    },
    WalletPlatform() {
      return WalletPlatform
    },
    NetworkNamespace() {
      return NetworkNamespace
    },
  },
})
export default class ConnectWalletChooseWallet extends MixinScreenSize {
  @Prop({type: Function, required: true}) onSelectWallet!: (
    namespace: NetworkNamespace,
    wallet?: WalletPlatform
  ) => Promise<void>
  @Prop({type: String, required: true})
  networkNamespace!: NetworkNamespace

  isN3Active =
    this.networkNamespace === NetworkNamespace.n3 &&
    !this.$walletAdapter.n3Address

  neonWalletIcon = neonWalletIcon
  neolineIcon = neolineIcon
  walletConnectIcon = walletConnectIcon
}
